import { render, staticRenderFns } from "./LeaderboardBreakdownModal.vue?vue&type=template&id=88e2639e&scoped=true&"
import script from "./LeaderboardBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./LeaderboardBreakdownModal.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardBreakdownModal.vue?vue&type=style&index=0&id=88e2639e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e2639e",
  null
  
)

export default component.exports